"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no draft of given courseId exists
 * @param {string} courseId
 */
class DraftDoesNotExistError extends client_library_1.ExtendableError {
    constructor(courseId) {
        super(`draft: ${courseId} does not exist`);
        this.courseId = courseId;
    }
}
exports.default = DraftDoesNotExistError;
//# sourceMappingURL=DraftDoesNotExistError.js.map